import { Suspense } from "react";
import { deepAddKey } from "@/utils/diffKey";
// import KeepAlive from "react-activation";

// const Home = lazy(() => import("@pages/Home"));
import Home from "@pages/Home";
// const HomeDefault = lazy(() => import("@components/HomeMain/Default"));
import HomeDefault from "@components/HomeMain/Default";
// const AlertDetail = lazy(() => import("@components/HomeMain/AlertDetail"));
import AlertDetail from "@components/HomeMain/AlertDetail";

// const AirQuality = lazy(() => import("@pages/AirQuality"));
import AirQuality from "@pages/AirQuality";
// const AirQualityDefault = lazy(() => import("@components/AirQualityMain/Default"));
import AirQualityDefault from "@components/AirQualityMain/Default";

// const Daily = lazy(() => import("@pages/Daily"));
import Daily from "@pages/Daily";
// const DailyDefault = lazy(() => import("@components/DailyMain/Default"));
import DailyDefault from "@components/DailyMain/Default";
// const DailyDetail = lazy(() => import("@components/DailyMain/Detail"));
import DailyDetail from "@components/DailyMain/Detail";

// const Hourly = lazy(() => import("@pages/Hourly"));
import Hourly from "@pages/Hourly";
// const HourlyDefault = lazy(() => import("@components/HourlyMain/Default"));
import HourlyDefault from "@components/HourlyMain/Default";

// const SunMoon = lazy(() => import("@pages/SunMoon"));
import SunMoon from "@pages/SunMoon";
// const SunMoonDefault = lazy(() => import("@components/SunMoonMain/Default"));
import SunMoonDefault from "@components/SunMoonMain/Default";

// const NotFound = lazy(() => import("@pages/404"));
import NotFound from "@pages/404";

// const ErrorView = lazy(() => import("@pages/ErrorView"));
import ErrorView from "@pages/ErrorView";

export const homeRoute = {
  path: "/home",
  element: <Home />,
  children: [
    {
      path: "",
      element: <HomeDefault />,
    },
    {
      path: "detail",
      element: <AlertDetail />,
    },
  ],
};

export const hourlyRoute = {
  path: "/hourly",
  element: <Hourly />,
  children: [
    {
      path: "",
      element: <HourlyDefault />,
    },
  ],
};
export const dailyDetailRoute: any = {
  path: "/daily/detail/:index",
  element: <DailyDetail />,
};
export const dailyRoute = {
  path: "/daily",
  element: <Daily />,
  children: [
    {
      path: "",
      element: <DailyDefault />,
    },
    dailyDetailRoute,
  ],
};

export const airQualityRoute = {
  path: "/air-quality",
  element: <AirQuality />,
  children: [
    {
      path: "",
      element: <AirQualityDefault />,
    },
  ],
};

export const sunMoonRoute = {
  path: "/sun-moon",
  element: <SunMoon />,
  children: [
    {
      path: "",
      element: <SunMoonDefault />,
    },
  ],
};
export const baseDeilyDetailPath = dailyDetailRoute.path.match(/^\/daily\/detail/)[0];
export const notFoundRoute = {
  path: "/notfound",
  element: <NotFound />,
};
export const errorViewRoute = {
  path: "/error",
  element: <ErrorView />,
};

export const rootRoute = {
  path: "/",
  element: <Navigate to={homeRoute.path} />,
};

export const redirectNotFound = {
  path: "*",
  element: <Navigate to="/notfound" />,
};

const BasicRouter: React.FC = () => {
  const defaultRoutes = [
    notFoundRoute,
    errorViewRoute,
    redirectNotFound,
    rootRoute,
    homeRoute,
    hourlyRoute,
    dailyRoute,
    airQualityRoute,
    sunMoonRoute,
  ];
  const asyncRoutes: any[] = [];
  const routeConfig = deepAddKey([...defaultRoutes, ...asyncRoutes]);
  const routeMap = (routes: any[]) => {
    return routes.map((route, index) => {
      if (!route?.children?.length) {
        return (
          <Route
            path={route.path}
            key={route.path + "-" + index}
            // key={route.diff_key}
            // element={
            //   <KeepAlive /* cacheKey={route.diff_key} name={route.diff_key} */>
            //     <Suspense fallback={<Loading />}>{route.element}</Suspense>
            //   </KeepAlive>
            // }
            element={<Suspense fallback={<Loading />}>{route.element}</Suspense>}
          />
        );
      }
      return (
        <Route
          path={route.path}
          key={route.path + "-" + index}
          // key={route.diff_key}
          element={<Suspense fallback={<Loading />}>{route.element}</Suspense>}
        >
          {routeMap(route.children)}
        </Route>
      );
    });
  };
  return <Routes>{routeMap(routeConfig)}</Routes>;
};
export default BasicRouter;
